import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {GlobalService} from "../../Services/global.service";
import * as moment from "moment";
import {Router, ActivatedRoute} from "@angular/router";
import {ScoreCardService} from "../../Services/score-card.service";
import {NgbTabChangeEvent} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
declare var $;

@Component({
  selector: 'app-isolated-score-card',
  templateUrl: './isolated-score-card.component.html',
  styleUrls: ['./isolated-score-card.component.css'],
  providers: [ScoreCardService]
})
export class IsolatedScoreCardComponent implements OnInit {

  @ViewChild('tabSet') tabSet;

  public beforeChange($event: NgbTabChangeEvent) {

    if ($event.nextId === 'ngb-lasttab-3') {
      $('.tab-content').addClass('topBorder');
    }else {
      $('.tab-content').removeClass('topBorder');
    }
    if ($event.nextId === 'instructionalTab') {
      $('.tab-content').addClass('topBorderRed');
    }else {
      $('.tab-content').removeClass('topBorderRed');
    }
  };

  courseData:any;
  courseNoData:boolean = false;
  tabName : any;
  screenWidth: number = 1366;
  redirectUrl: string = '';

  constructor(private ScoreCardService : ScoreCardService, private route : Router, private  translateService : TranslateService, private activatedRoute: ActivatedRoute) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.use(lang_name);
    this.translateService.reloadLang(lang_name);
  }

  gameList : Array<any> = [];
  gameData : Array<any> = [];
  videoData : Array<any> = [];
  resourceData : Array<any> = [];
  certificatesData : Array<any> = [];
  transaction : Array<any> = [];
  course_id:string = '';
  noData:string = '';
  levelName:any;
  //sorting
  key: string = 'name';
  reverse: boolean = false;
  caseInsensitive: boolean = true;
  doneCertificates = [];
  doneBadges = [];
  isVisibleBtn: boolean = false;
  tour: any;
  loginMsg = '';

  setOrder(key : string){
    if (this.key === key) {
      this.reverse = !this.reverse;
    }
    this.key = key;

    if(this.key == 'name'){
      $(".asceSortingName").toggleClass("descSort");
    }else  if(this.key == 'attempts'){
      $(".asceSortingAttempts").toggleClass("descSort");
    }else  if(this.key == 'score'){
      $(".asceSortingScore").toggleClass("descSort");
    }

  }
  courseLevels = [];
  dataLoad:boolean = true;

  ngOnInit() {
    $("header").css('display','none');
    $("footer").css('display','none');
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    window.name = 'isolatedScoreCardScreen';
    $("#preloader").css('display','block');

    this.screenWidth = screen.width || window.screen.width;
    localStorage.setItem('currentScreen', 'SCORECARD');

    this.activatedRoute.params.subscribe(params => {
      if(params['url']){
        let id = params['url'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
        }
      }
    });

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let Role = localStorage.getItem('userRole');
    if(Role && (Role == 'Learner' || Role == 'Manager')){
      if(currentUser && currentUser.user){
        const user_id = currentUser.user.userid;
        const role = currentUser.user.role;
        let language_id = localStorage.getItem('defaultLangId');
        let cnt =0;
        if(currentUser && user_id && language_id){

          if(role && (role == 'Learner' || role=='Manager')){
            this.ScoreCardService.getSubscribedCourses(user_id, language_id)
              .subscribe(courses =>{
                cnt +=1;
                this.translateService.get(['SCORECARD.INSTRUCTION', 'SCORECARD.CERTIFICATIONS', 'SCORECARD.SCORECARDTITLE', 'SCORECARD.EARNEDCERF', 'SCORECARD.NOTEARNEDCERF', 'SCORECARD.EARNEDBADGE', 'SCORECARD.EARNEDCERFTITLE', 'SCORECARD.RESOURCE']).subscribe(label =>{
                  this.tabName = label;
                });
                if(courses.data.length > 0) {
                  this.courseData = courses.data;
                }else {
                  this.courseNoData = true;
                }
                if(cnt == 2){
                  this.isCertAvail();
                }
                $("#preloader").css('display','none');
              });

            this.ScoreCardService.getCompletedCertificates(user_id, language_id).subscribe(res => {
              cnt += 1;
              if(res.success){
                this.doneCertificates = res.data.finalCertificates;
                this.doneBadges = res.data.finalBadges;
              }else {
                this.doneCertificates = [];
                this.doneBadges = [];
              }
              if(cnt == 2){
                this.isCertAvail();
              }
            });

            $('.learnerCommonFooter').css('display','block');
          }else{
            this.loginMsg = '200';
            $('#msgModal').modal('show');
            $('.learnerCommonFooter').css('display','block');
            $("#preloader").css('display','none');
          }
        }else{
          this.loginMsg = '200';
          $('#msgModal').modal('show');
          $('.learnerCommonFooter').css('display','block');
          $("#preloader").css('display','none');
        }
      }else{
        this.loginMsg = '200';
        $('#msgModal').modal('show');
        $('.learnerCommonFooter').css('display','block');
        $("#preloader").css('display','none');
      }
    }else{
	    this.loginMsg = '201';
        $('#msgModal').modal('show');
        $('.learnerCommonFooter').css('display','block');
      $("#preloader").css('display','none');
    }
  }


  ngAfterViewInit(){

  }

  getHrefVal(name){
    return '#' + name;
  }

  clickCourse(e, t, k){
    $("#preloader").css('display','block');
    this.tabSet = t;
    this.course_id = e;
    this.certificatesData = [];
    let language_id = localStorage.getItem('defaultLangId');
    this.ScoreCardService.getCourseLevelsByCourseId(this.course_id, language_id).subscribe(res => {
      if(res.success){
        this.courseLevels = res.data;
        if(this.courseLevels.length > 0){
          this.getGamesByLevel(this.courseLevels[0].level_id, 'clickCourse', t, k, this.courseLevels[0].name);
        } else {
          this.getInstructionDetails();
          /*this.getResourceDetails();*/
        }
      }
    });
  }


  getTabId(name, id, k){
    const uniqId : string = k + name + id;
    return uniqId.replace(/[^a-zA-Z0-9]/g, '');
  }

  getGamesByLevel(level_id, flag, tab, k, name){
    $("#preloader").css('display','block');
    this.getLevelName(name);// This is called to collapse the tab for mobile view
    this.dataLoad = false;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const user_name = currentUser.user.userid;
    let language_id = localStorage.getItem('defaultLangId');
    this.ScoreCardService.getCourseGamesByLevels(this.course_id, level_id, user_name, language_id).subscribe(res => {
      $("#preloader").css('display','none');
      if(res.success){
        //set flag to true for dataLoad for the issue where Instructional and Certification tabs are not displaying --28/02/19
        this.dataLoad = true;

        if(this.courseLevels[0].level_id == level_id) {
          const id: string = k + this.courseLevels[0].level_id + this.course_id;
          const newId = id.replace(/[^a-zA-Z0-9]/g, '');
          tab.select(newId);
        }
        if(res.data.length > 0){
          this.gameData = res.data;
          this.noData = '';

          if($('.tab-content').hasClass('topBorder')){
            $('.tab-content').removeClass('topBorder');
          }
          if($('.tab-content').hasClass('topBorderRed')){
            $('.tab-content').removeClass('topBorderRed');
          }
        }else {
          this.gameData = [];
          this.noData = '211';
        }
      }else {
        this.noData = '211';
      }
    });
  }

  getLevelName(name){
    if ($(window).width() < 823) { /*if ($(window).width() < 500)*/
      // alert('Less than 500');
      ($(window).height() < 1000) ? $('.nav-tabs ').addClass('displayNone') : $('.nav-tabs ').removeClass('displayNone');
    }
    else {
      //alert('More than 500');
    }
    this.levelName = name;
  }
  collapseTab(name){
    $('.nav-tabs').toggleClass('displayNone');
  }

  getInstructionDetails(){
    $("#preloader").css('display','block');
    this.getLevelName(this.tabName['SCORECARD.INSTRUCTION']); // This is called to collapse the tab for mobile view
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const user_id = currentUser.user.userid;
    let language_id = localStorage.getItem('defaultLangId');
    this.ScoreCardService.getCourseVideos(this.course_id, user_id, language_id)
      .subscribe(course =>{
        $("#preloader").css('display','none');
        if(course.success){
          if(course.data.length > 0){
            this.videoData = course.data;
            this.noData = '';
          }else {
            this.noData = '211';
          }
        }else {
          this.noData = '211';
        }
      });
  }

  getResourceDetails(){
    $("#preloader").css('display','block');
    this.getLevelName(this.tabName['SCORECARD.RESOURCE']); // This is called to collapse the tab for mobile view
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const user_id = currentUser.user.userid;
    let language_id = localStorage.getItem('defaultLangId');
    this.ScoreCardService.getCourseResources(this.course_id, user_id, language_id)
      .subscribe(course =>{
        $("#preloader").css('display','none');
        if(course.success){
          if(course.data.length > 0){
            this.resourceData = course.data;
            this.noData = '';
          }else {
            this.noData = '211';
          }
        }else {
          this.noData = '211';
        }
      });
  }

  getCertifiacteDetails(){
    $("#preloader").css('display','block');
    this.getLevelName(this.tabName['SCORECARD.CERTIFICATIONS']);// This is called to collapse the tab for mobile view
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const user_id = currentUser.user.userid;
    let language_id = localStorage.getItem('defaultLangId');


    this.ScoreCardService.getCourseScoreCardByLevel(this.course_id, 'Certifications', user_id, language_id)
      .subscribe(certificates =>{
        $("#preloader").css('display','none');
        if(certificates.success){
          if(certificates.data.length > 0){
            this.certificatesData = certificates.data;

            this.noData = '';
          }else {
            this.certificatesData = certificates.data;
            this.noData = '211';
          }
        }
      });
  }

  getDate(date){
    return moment(date).format("MM/DD/YYYY");
  }

  gotoFirstModule(){
    if(this.courseData[0].course_id) {
      localStorage.setItem('redirectFrom', 'start_certificate');
      this.route.navigate(['/dashboard/learner/learnerDashboard/moduleDetails/' + this.courseData[0].course_id]);
    }
  }
  toggleEarnCertf(){
    $('.earnedCertfPanel').toggleClass('displayBlock');
  }


  getcolor(index, count) {
    count = count - 1;

    //for R Value
    let initR = 215, lastR : number = 142;
    let Rdiff = initR - lastR;
    let Rfactor = (Rdiff / count);
    Rfactor = Rfactor * index;
    let R = Math.round(initR - Rfactor);

    ///fro G value
    let initG = 240, lastG = 198;
    let Gdiff = initG - lastG;
    let Gfactor = (Gdiff / count);
    Gfactor = Gfactor * index;
    let G = Math.round(initG - Gfactor);

    //For B value
    let initB = 179, lastB = 63;
    let Bdiff = initB - lastB;
    let Bfactor = (Bdiff / count);
    Bfactor = Bfactor * index;
    let B = Math.round(initB - Bfactor);

    let colorvalue = "rgb(" + R + "," + G + "," + B + ")";
    //var colorvalue = "rgb(215," + G + ",179)";
    //alert("colorvalue"+colorvalue);
    return colorvalue;
  }

  getHighestScore(score){
    let max = 0;
    for(let i=0; i< score.length; i++){
      let sr = score[i].toString();
      let s = parseInt(sr.split(":")[0]);
      if(s > max){
        max = s;
      }
    }
    return max;
  }

  isCertAvail(){
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const community_id = currentUser.user.community_id;
    if(this.doneCertificates && this.doneCertificates.length > 0){
      this.isVisibleBtn = false;
    }else{
      if(this.courseData && this.courseData.length > 0){
        let certIdArr = [];
        for(let a=0; a < this.courseData.length; a++){
          if(this.courseData[a].certificates && this.courseData[a].certificates.length > 0){
            certIdArr.push.apply(certIdArr, this.courseData[a].certificates);
          }
        }
        if(certIdArr && certIdArr.length > 0){
          let obj = {
            comm_id: community_id,
            certIdArr: certIdArr
          };
          this.ScoreCardService.getCertInLicense(obj).subscribe(res =>{
            if(res.success){
              this.isVisibleBtn = res.data;
            }
          });
        }else{
          this.isVisibleBtn = false;
        }
      }else{
        this.isVisibleBtn = false;
      }
    }
  }

  closeMsgModal(){
    this.loginMsg = '';
    $('#msgModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-score-card/isolated-score-card.component.ts